module.exports = __webpack_public_path__ + "img/Postnatal Multivitamin.9da947dc.png";